import React, { useEffect, useState, useContext } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Card, CardHeader } from "@mui/material";
import DataTable from "examples/Tables/DataTable";
import Pagination from "@mui/material/Pagination";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useNavigate } from "react-router-dom";
import AppointmentsApi from "../../../Classes/API/Appointments/AppointmentsApi";
import SearchStringOrIntReq from "../../../Classes/Models/Requests/SearchStringOrIntReq";
import PatientSelector from "CinicComponents/PatientSelector";
import MDButton from "components/MDButton";
import { LanguageContext } from "App";
import Swal from "sweetalert2";

const index = () => {
  let navigate = useNavigate();

  const [SearchReq, setSearchReq] = useState(new SearchStringOrIntReq());
  const [ResponseData, setResposneData] = useState({});
  const [IsLoaded, setIsLoaded] = useState(false);
  const [TableDataRows, setTableDataRows] = useState([]);
  const { translations } = useContext(LanguageContext);
  const [Patient, setPatient] = useState(null);

  const [Page, setPage] = useState(1);
  const [TotalPages, setTotalPages] = useState(0);
  const TableColumns = [
    {
      Header: translations.appointmentpatientprogrammetableProgramID,
      accessor: "ProgramId",
      align: "left",
    },
    {
      Header: translations.appointmentpatientprogrammetablePatient,
      accessor: "Patient",
      align: "left",
    },
    { Header: translations.appointmentpatientprogrammetableGo, accessor: "Details", align: "left" },
  ];

  const MakeTableRow = (log) => {
    return {
      Patient: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.patient.getUser?.id} | {log.patient.getUser?.name}
        </MDTypography>
      ),

      ProgramId: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.id}
        </MDTypography>
      ),
      Details: (
        <MDButton
          onClick={() => navigate(`/patientprograms/details`, { state: { program: log } })}
          variant="contained"
          color="secondary"
        >
          {translations.appointmentpatientprogrammetableGo}
        </MDButton>
      ),
    };
  };

  const RefreshTable = (resList) => {
    var rows = [];
    resList?.forEach((Entry) => {
      rows.push(MakeTableRow(Entry));
    });
    setTableDataRows(rows);
  };

  useEffect(async () => {
    if (Object.keys(ResponseData).length > 1) {
      RefreshTable(ResponseData.list);
    }
  }, [ResponseData]);

  useEffect(() => {
    //Check if data is loaded
    if (Object.keys(ResponseData).length > 0) {
      setIsLoaded(true);
    } else {
      setIsLoaded(false);
    }
  }, [ResponseData]);

  const onSearch = async () => {
    console.log(SearchReq);
    SearchReq.pagingParams.pageNumber = Page;
    SearchReq.pagingParams.pageSize = 10;
    SearchReq.SearchInt = Patient?.getPatient?.id;
    var res = await AppointmentsApi.SearchPatientPrograms(SearchReq);
    if (res.status == "Success") {
      console.log(res);
      setResposneData(res.data);
      setTotalPages(res.data.totalPages);
    } else {
      Swal.fire({
        icon: "error",
        text: res.status.message,
      });
    }
  };

  useEffect(() => {
    console.log(SearchReq);
    onSearch();
  }, [SearchReq]);

  useEffect(() => {
    onSearch();
  }, [Page]);

  if (!IsLoaded) {
    return (
      <div>
        <MDBox>
          <MDTypography component="a" variant="button" color="text" fontWeight="medium">
            Loading Log Data...
          </MDTypography>
        </MDBox>
      </div>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className="row">
        <div className="col-md-3">
          <PatientSelector setPatient={setPatient} />
        </div>
        <div className="col-md-6">
          <MDButton
            sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
            color="info"
            onClick={onSearch}
          >
            {translations.appointmentpatientprogrammetablesearch}
          </MDButton>
        </div>
      </div>

      <Card className="mt-5">
        <MDBox
          mt={-3}
          py={3}
          px={2}
          sx={{
            backgroundColor: "#3560AD",

            borderTopLeftRadius: "1.1rem",

            borderTopRightRadius: "1.1rem",
          }}
          bgColor="info"
          coloredShadow="info"
        >
          <div className="text-center">
            <MDTypography variant="h6" color="white">
              {translations.appointmentpatientprogrammetable}
            </MDTypography>
          </div>
        </MDBox>

        <div className="container mt-3"></div>

        <MDBox p={3}>
          <DataTable
            table={{ columns: TableColumns, rows: TableDataRows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />
        </MDBox>

        <div className="text-right mx-3 my-4">
          <Pagination
            count={TotalPages}
            onChange={(e, num) => setPage(num)}
            color="primary"
            className="float-right"
          />
        </div>
      </Card>
    </DashboardLayout>
  );
};

export default index;
